export var ServiceDealGroupType;
(function (ServiceDealGroupType) {
    ServiceDealGroupType[ServiceDealGroupType["ALL"] = 0] = "ALL";
    ServiceDealGroupType[ServiceDealGroupType["INVENTORY"] = 1] = "INVENTORY";
    ServiceDealGroupType[ServiceDealGroupType["GROUP"] = 2] = "GROUP";
})(ServiceDealGroupType || (ServiceDealGroupType = {}));
export var DealGroupType;
(function (DealGroupType) {
    DealGroupType["ALL"] = "All";
    DealGroupType["INVENTORY"] = "Inventory";
    DealGroupType["GROUP"] = "Group";
})(DealGroupType || (DealGroupType = {}));
export var DealGroupTypeToServiceDealGroupType;
(function (DealGroupTypeToServiceDealGroupType) {
    DealGroupTypeToServiceDealGroupType[DealGroupTypeToServiceDealGroupType["All"] = 0] = "All";
    DealGroupTypeToServiceDealGroupType[DealGroupTypeToServiceDealGroupType["Inventory"] = 1] = "Inventory";
    DealGroupTypeToServiceDealGroupType[DealGroupTypeToServiceDealGroupType["Group"] = 2] = "Group";
})(DealGroupTypeToServiceDealGroupType || (DealGroupTypeToServiceDealGroupType = {}));
export var DealArchiveStatus;
(function (DealArchiveStatus) {
    DealArchiveStatus["ACTIVE"] = "Active";
    DealArchiveStatus["ARCHIVED"] = "Archived";
    DealArchiveStatus["BOTH"] = "Both";
})(DealArchiveStatus || (DealArchiveStatus = {}));
export var DealSourceType;
(function (DealSourceType) {
    DealSourceType["SELF_SOURCED"] = "Self-Sourced";
    DealSourceType["MADHIVE_PRIVATE"] = "MadSupply";
    DealSourceType["MADHIVE_PUBLIC"] = "Madhive-Sourced Deals";
    DealSourceType["PRIVATE_O_AND_O"] = "Private O&O";
})(DealSourceType || (DealSourceType = {}));
export var ServiceDealSourceType;
(function (ServiceDealSourceType) {
    ServiceDealSourceType["CLIENT"] = "CLIENT";
    ServiceDealSourceType["MADHIVE"] = "MADHIVE";
    ServiceDealSourceType["O_AND_O"] = "O_AND_O";
    ServiceDealSourceType["SELF_SOURCED"] = "SELF_SOURCED";
    ServiceDealSourceType["MADHIVE_PRIVATE"] = "MADHIVE_PRIVATE";
    ServiceDealSourceType["MADHIVE_PUBLIC"] = "MADHIVE_PUBLIC";
    ServiceDealSourceType["PRIVATE_O_AND_O"] = "PRIVATE_O_AND_O";
})(ServiceDealSourceType || (ServiceDealSourceType = {}));
//# sourceMappingURL=types.js.map